import React, { useEffect } from "react";
import { UserContext } from "../UserContext";
import { Redirect } from "react-router-dom";
import { useSetupUserProfile } from "./useSetupUserProfile";
import { SetupUser } from "./SetupUser";
import { User } from "./User";

const API_PATH = "/api/user/sessionDetails";

export function NoTenantUserContextProvider(props) {
  const profile = useSetupUserProfile(API_PATH);
  const user = new User(profile);
  const success = user.isSuccess();
  const fetching = user.isFetching();
  const error = user.isError();

  useEffect(() => {
    if (success && !error) {
      const isSiaaAgency = user.isSiaaAgency();
      if (isSiaaAgency) {
        document.title = "AgencyIQ";
      } else {
        document.title = "DONNA ai";
      }
    }
  }, [success, error]);

  return (
    <UserContext.Provider value={{ user: user }}>
      {fetching && <div>Loading...</div>}
      {error && <Redirect to="/login/retry" />}
      {success && props.children}
    </UserContext.Provider>
  );
}
